// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullSessionItem_progress{
    padding: 2px 2px;
    align-items: stretch;
    position: relative;
    flex-shrink: 0;

    background: #FFFFFF;
    border: 1px solid #14AE5C;
    border-radius: 24px;
    display: flex;
    gap: 8px;

    width: var(--sessionButtonWidth);
    height: 29px;

    display: flex;
    align-items: center;
}

.fullSessionItem_progress_bar{
    border-radius: 20px;
    background: #14AE5C;
    height: 100%;
    overflow: hidden;
    position: relative;
    z-index: 1;
}

.fullSessionItem_progress_percent{
    position: absolute;
    width: calc(var(--buttonWidth) - 4px);
    height: calc(29px - 4px);
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 14px;

    color: #000;
    z-index: 2;
    pointer-events: none;
}

.fullSessionItem_progress_percent_white{
    color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sessions/fullSessionItem/FullSessionProgress.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;;IAEd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,QAAQ;;IAER,gCAAgC;IAChC,YAAY;;IAEZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,WAAW;IACX,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".fullSessionItem_progress{\n    padding: 2px 2px;\n    align-items: stretch;\n    position: relative;\n    flex-shrink: 0;\n\n    background: #FFFFFF;\n    border: 1px solid #14AE5C;\n    border-radius: 24px;\n    display: flex;\n    gap: 8px;\n\n    width: var(--sessionButtonWidth);\n    height: 29px;\n\n    display: flex;\n    align-items: center;\n}\n\n.fullSessionItem_progress_bar{\n    border-radius: 20px;\n    background: #14AE5C;\n    height: 100%;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n}\n\n.fullSessionItem_progress_percent{\n    position: absolute;\n    width: calc(var(--buttonWidth) - 4px);\n    height: calc(29px - 4px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 14px;\n\n    color: #000;\n    z-index: 2;\n    pointer-events: none;\n}\n\n.fullSessionItem_progress_percent_white{\n    color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
